<div class="complaint-form" [class.mobile]="!deviceService.isDesktop()">
  <div class="header">
    <h2 class="title">{{ init.title | translate }}</h2>
    <span class="subtitle normal">{{ init.subtitle | translate }}</span>
    <div class="close-btn" (click)="onCancel()">
      <app-icon width="20" height="20" icon="close"></app-icon>
    </div>
  </div>

  <div class="form">
    <label *ngFor="let cause of init.causes; let i = index; trackBy: trackByFn" class="cause-wrap">
      <input type="radio" name="cause" class="cause-input" [value]="i" [(ngModel)]="selectedCauseIdx">
      <span class="cause-radio"></span>
      <span class="cause-label normal">{{ cause | translate }}</span>
    </label>
    <span class="comments-label">{{ 'content.comments-label' | translate }}</span>
    <div #input
         class="comment normal"
         contenteditable="true"
         [attr.placeholder]="init.comment_placeholder | translate"
         (input)="onInput($event)">
    </div>
  </div>

  <div class="button-block">
    <div class="button-wrap">
      <on-ui-button class="primary outline"
                    [label]="init.cancel_label"
                    (onclick)="onCancel()">
      </on-ui-button>
    </div>
    <div class="button-wrap">
      <on-ui-button class="danger"
                    [disabled]="selectedCauseIdx==null"
                    [label]="init.send_label"
                    (onclick)="onSend()">
      </on-ui-button>
    </div>
  </div>

  <ng-template [ngIf]="sendInformation">
    <div class="send-information">
      <app-icon width="90" height="90" icon="complaint"></app-icon>
      <h2 class="info-title">{{ 'complaint-form.info-title' | translate }}</h2>
      <span class="info-close medium" (click)="onCancel()">{{ 'complaint-form.close' | translate }}</span>
    </div>
  </ng-template>
</div>
